function WorkspaceLoading() {
  return (
    <div className="loading-shell">
      <div className="loading-card large" />
      <div className="loading-grid">
        <div className="loading-card" />
        <div className="loading-card" />
        <div className="loading-card" />
      </div>
      <div className="loading-card medium" />
    </div>
  );
}

export default WorkspaceLoading;
